import React, { useState, useEffect } from "react";

import cup from "../../../../../assets/images/cup 2.png";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import EnterImage from "../../../../../assets/images/unsplash_hUHzaiAHuUc.png";
import { Markup } from "interweave";
import axios from "axios";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import PromotionalCard from "../../../../Reuseable/PromotionalCard";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const PromotionalList = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get("/api/superstar/promotional/video/list").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title={"Auditions Promotional List"} image={cup} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <PromotionalCard
          data={event_data}
          urlLink={`/superstar/audition/promotional-view`}
        />
      )}
  
    </>
  );
};

export default PromotionalList;
